import { Box } from '@mui/material';
import { ReactElement } from 'react';
import { HeapMaskEntry } from '../../Heap/heapMasks';
import { HeapFrameNavigation } from './HeapFrameNavigation';
import { HeapMaskChipBar } from './HeapMaskChipBar';

interface HeapImageToolbarProps {
  maskEntries: readonly HeapMaskEntry[];
  onMaskVisibilityChange: (maskId: string, visible: boolean) => void;
  onMaskOpacityChange: (maskId: string, opacity: number) => void;
  currentIndex: number;
  totalCount: number;
  onPrevious: () => void;
  onNext: () => void;
}

export function HeapImageToolbar({
  maskEntries,
  onMaskVisibilityChange,
  onMaskOpacityChange,
  currentIndex,
  totalCount,
  onPrevious,
  onNext,
}: HeapImageToolbarProps): ReactElement | null {
  const hasMasks = maskEntries.length > 0;
  const hasFrames = totalCount > 1;

  if (!hasMasks && !hasFrames) return null;

  return (
    <Box display='flex' alignItems='center' gap={1} paddingX={1} minHeight={40} flexShrink={0}>
      {hasFrames && (
        <HeapFrameNavigation
          currentIndex={currentIndex}
          totalCount={totalCount}
          onPrevious={onPrevious}
          onNext={onNext}
        />
      )}

      {hasMasks && (
        <HeapMaskChipBar
          entries={maskEntries}
          onVisibilityChange={onMaskVisibilityChange}
          onOpacityChange={onMaskOpacityChange}
        />
      )}
    </Box>
  );
}
